import Form from "./form/Form";
import Logo from "./logo/Logo";
import Stats from "./states/Stats";
import PopUp from "./popUo/PopUp";
import List from "./list/List";
import "./App.css";
import { useEffect, useReducer, useState } from "react";
import { type } from "@testing-library/user-event/dist/type";
import useDocumentTitle from "./testHOOOKS";
import Revesttttttttttttt from "./revesttttttttttttt";

function reducer(state, action) {
  // useWindowWidth();

  switch (action.type) {
    case "items":
      return { ...state, itemsList: action.payload };
    case "cases":
      return { ...state, Case: action.payload };
    case "status":
      return { ...state, status: action.payload };
    case "id":
      return { ...state, id: action.payload };
    case "oneTask":
      return { ...state, oneTask: action.payload };
    case "show":
      return { ...state, show: action.payload };
    case "button":
      return { ...state, button: action.payload };
    default:
      return state;
  }
}
function App() {
  // useDocumentTitle();
  // console.log(useDocumentTitle());
  useDocumentTitle("new page");
  console.log(document.title);

  let [state, dispatch] = useReducer(reducer, {
    itemsList: JSON.parse(localStorage.getItem("items")) ?? [],
    status: "Pending",
    oneTask: "",
    Case: true,
    id: "",
    show: false,
    button: "ADD",
  });
  let { itemsList, status, oneTask, Case, id, show, button } = state;
  function handleitemsList(item) {
    if (Case) {
      const updatesItemList = [...itemsList, item];
      dispatch({ type: "items", payload: updatesItemList });
      localStorage.setItem("items", JSON.stringify(updatesItemList));
    } else {
      let updatesItemList = itemsList.map((item) =>
        item.id === id ? { ...item, oneTask } : item
      );
      console.log(itemsList);
      dispatch({ type: "items", payload: updatesItemList });
      dispatch({ type: "cases", payload: true });
      localStorage.setItem("items", JSON.stringify(updatesItemList));
    }
  }
  useEffect(() => {
    document.title = "Tasks - My App";
  }, []);

  function deleteElement(id) {
    dispatch({
      type: "items",
      payload: itemsList.filter((ele) => ele.id !== id),
    });
    localStorage.setItem("items", JSON.stringify(itemsList));
  }

  function updateElement(id) {
    let updatedItem = itemsList.filter((ele) => {
      return ele.id === id;
    });
    console.log(updatedItem);
    dispatch({ type: "oneTask", payload: updatedItem[0].oneTask });
    dispatch({ type: "cases", payload: false });
    dispatch({ type: "id", payload: updatedItem[0].id });
    dispatch({ type: "button", payload: "Update" });
    localStorage.setItem("items", JSON.stringify(itemsList));
  }

  function handleCheck(id) {
    let updatedItem = itemsList.map((ele) =>
      ele.id === id
        ? { ...ele, status: ele.status === "Done" ? "pending" : "Done" }
        : ele
    );

    dispatch({ type: "items", payload: updatedItem });
  }

  return (
    <div>
      <Logo />
      <Form
        additem={handleitemsList}
        status={status}
        button={button}
        setStatus={dispatch}
        oneTask={oneTask}
        dispatch={dispatch}
      />
      <List
        itemsList={itemsList}
        deleteFun={deleteElement}
        updateFun={updateElement}
        handleCheck={handleCheck}
        dispatch={dispatch}
        status={status}
      />
      <Stats itemsList={itemsList} />
      <PopUp show={show} dispatch={dispatch} />
    </div>
  );
}

export default App;
